import { useState } from 'react'
import { useNavigate } from 'react-router-dom'

function HelpPage() {
  const navigate = useNavigate()
  const [activeSection, setActiveSection] = useState('general')
  const [searchQuery, setSearchQuery] = useState('')
  const [expandedFaq, setExpandedFaq] = useState(null)

  const sections = [
    { id: 'general', name: 'Questions générales', icon: '❓' },
    { id: 'account', name: 'Compte & Profil', icon: '👤' },
    { id: 'publish', name: 'Publication', icon: '📝' },
    { id: 'payment', name: 'Paiement', icon: '💳' },
    { id: 'security', name: 'Sécurité', icon: '🔒' },
    { id: 'contact', name: 'Contact', icon: '📧' }
  ]

  const faqs = {
    general: [
      {
        question: "Qu'est-ce que KUDHI ?",
        answer: "KUDHI est une plateforme de mise en relation qui connecte vendeurs et acheteurs, entreprises et particuliers. Publiez vos annonces, recherchez des produits et services, et échangez en toute sécurité."
      },
      {
        question: "Comment utiliser KUDHI ?",
        answer: "Inscrivez-vous gratuitement, créez votre profil, puis publiez vos annonces ou recherchez des produits qui vous intéressent. Vous pouvez filtrer par catégories et localisation."
      },
      {
        question: "KUDHI est-il gratuit ?",
        answer: "Oui, KUDHI est gratuit pour publier des annonces classiques. Des options premium sont disponibles pour augmenter la visibilité de vos annonces."
      },
      {
        question: "Dans quelles régions KUDHI est-il disponible ?",
        answer: "KUDHI est disponible dans toute la Côte d'Ivoire. Vous pouvez filtrer les résultats par ville ou région pour trouver des annonces près de chez vous."
      }
    ],
    account: [
      {
        question: "Comment créer un compte ?",
        answer: "Cliquez sur 'S'inscrire' en haut de la page, renseignez vos informations (nom, email, téléphone) et créez un mot de passe. Vous recevrez un code de vérification par SMS."
      },
      {
        question: "J'ai oublié mon mot de passe",
        answer: "Cliquez sur 'Mot de passe oublié' sur la page de connexion. Entrez votre email ou numéro de téléphone, et suivez les instructions pour réinitialiser votre mot de passe."
      },
      {
        question: "Comment modifier mes informations personnelles ?",
        answer: "Accédez à votre profil en cliquant sur votre photo, puis sélectionnez 'Modifier le profil'. Vous pourrez y modifier vos informations et votre photo."
      },
      {
        question: "Comment supprimer mon compte ?",
        answer: "Contactez notre support via le formulaire de contact en demandant la suppression de votre compte. Toutes vos données seront supprimées sous 30 jours."
      }
    ],
    publish: [
      {
        question: "Comment publier une annonce ?",
        answer: "Cliquez sur le bouton '+' en bas à droite, choisissez le type d'annonce (Image, Vidéo, Bannière), remplissez les informations et ajoutez des photos. Cliquez sur 'Publier'."
      },
      {
        question: "Combien de photos puis-je ajouter ?",
        answer: "Vous pouvez ajouter jusqu'à 3 photos pour une annonce standard. La première photo sera utilisée comme image principale."
      },
      {
        question: "Comment modifier ou supprimer mon annonce ?",
        answer: "Accédez à 'Mes annonces' depuis votre profil, trouvez l'annonce à modifier, puis cliquez sur les options d'édition ou de suppression."
      },
      {
        question: "Combien de temps mon annonce reste-t-elle en ligne ?",
        answer: "Les annonces standard restent en ligne pendant 30 jours. Vous pouvez les renouveler gratuitement ou opter pour une option premium pour plus de visibilité."
      },
      {
        question: "Quelles sont les règles de publication ?",
        answer: "Vous devez publier des annonces honnêtes, avec des photos réelles. Les produits interdits, contrefaçons ou contenus inappropriés sont strictement interdits."
      }
    ],
    payment: [
      {
        question: "Quels sont les moyens de paiement acceptés ?",
        answer: "Nous acceptons les paiements par mobile money (Orange Money, MTN Money), virement bancaire et cartes bancaires pour les services premium."
      },
      {
        question: "Comment fonctionne le paiement entre acheteur et vendeur ?",
        answer: "KUDHI ne gère pas les transactions. Les paiements se font directement entre acheteurs et vendeurs, selon les modalités convenues entre eux."
      },
      {
        question: "Les transactions sont-elles sécurisées ?",
        answer: "Nous recommandons de rencontrer les vendeurs en personne dans des lieux publics et de vérifier les produits avant paiement. Méfiez-vous des offres trop alléchantes."
      },
      {
        question: "Puis-je obtenir un remboursement ?",
        answer: "Les remboursements concernent uniquement les services premium KUDHI. Pour les transactions entre utilisateurs, contactez directement le vendeur."
      }
    ],
    security: [
      {
        question: "Comment éviter les arnaques ?",
        answer: "Rencontrez toujours les vendeurs en personne, vérifiez les produits avant paiement, méfiez-vous des prix trop bas, et ne payez jamais à l'avance sans garantie."
      },
      {
        question: "Comment signaler une annonce suspecte ?",
        answer: "Cliquez sur l'icône de signalement sur l'annonce, sélectionnez la raison et fournissez des détails. Notre équipe examinera le signalement rapidement."
      },
      {
        question: "Mes données personnelles sont-elles protégées ?",
        answer: "Oui, nous utilisons un cryptage SSL et ne partageons jamais vos données personnelles avec des tiers sans votre consentement. Consultez notre politique de confidentialité."
      },
      {
        question: "Que faire en cas de fraude ?",
        answer: "Contactez immédiatement notre support et signalez l'utilisateur. Si une transaction financière est impliquée, contactez également les autorités compétentes."
      }
    ],
    contact: [
      {
        question: "Comment contacter le support ?",
        answer: "Utilisez le formulaire de contact ci-dessous, envoyez-nous un email à support@KUDHI.ci, ou appelez-nous au +225 07 00 00 00 00 (du lundi au vendredi, 9h-18h)."
      },
      {
        question: "Quel est le délai de réponse du support ?",
        answer: "Nous nous engageons à répondre à toutes les demandes dans un délai de 24 à 48 heures ouvrables."
      },
      {
        question: "Puis-je vous contacter via WhatsApp ?",
        answer: "Oui, vous pouvez nous contacter sur WhatsApp au +225 07 00 00 00 00 pour une assistance rapide."
      }
    ]
  }

  const filteredFaqs = searchQuery
    ? Object.values(faqs).flat().filter(faq =>
        faq.question.toLowerCase().includes(searchQuery.toLowerCase()) ||
        faq.answer.toLowerCase().includes(searchQuery.toLowerCase())
      )
    : faqs[activeSection] || []

  return (
    <div className="min-h-screen bg-[#fefcf8]">
      <div className="w-full md:w-[90%] lg:w-[80%] mx-auto px-4 py-8">
        {/* Header */}
        <div className="bg-gradient-to-r from-[#D4AF37] to-[#c09d2a] rounded-2xl p-8 md:p-12 mb-8 text-white">
          <h1 className="text-3xl md:text-4xl font-bold mb-4">Centre d'aide</h1>
          <p className="text-lg mb-6">Comment pouvons-nous vous aider aujourd'hui ?</p>
          
          {/* Barre de recherche */}
          <div className="relative max-w-2xl">
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              placeholder="Rechercher dans l'aide..."
              className="w-full px-6 py-4 rounded-xl text-[#001F3F] placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-white"
            />
            <svg
              className="absolute right-4 top-1/2 -translate-y-1/2 w-6 h-6 text-gray-400"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
            </svg>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-4 gap-6">
          {/* Sidebar - Catégories */}
          <div className="lg:col-span-1">
            <div className="bg-white rounded-xl shadow-sm p-4 sticky top-20">
              <h3 className="font-bold text-[#001F3F] mb-4">Catégories</h3>
              <div className="space-y-2">
                {sections.map((section) => (
                  <button
                    key={section.id}
                    onClick={() => {
                      setActiveSection(section.id)
                      setSearchQuery('')
                    }}
                    className={`w-full text-left px-4 py-3 rounded-lg transition-colors ${
                      activeSection === section.id
                        ? 'bg-[#D4AF37] text-white'
                        : 'hover:bg-gray-100 text-[#001F3F]'
                    }`}
                  >
                    <span className="mr-2">{section.icon}</span>
                    <span className="text-sm font-medium">{section.name}</span>
                  </button>
                ))}
              </div>
            </div>
          </div>

          {/* Contenu principal - FAQ */}
          <div className="lg:col-span-3">
            <div className="bg-white rounded-xl shadow-sm p-6 md:p-8">
              <h2 className="text-2xl font-bold text-[#001F3F] mb-6">
                {searchQuery ? 'Résultats de recherche' : sections.find(s => s.id === activeSection)?.name}
              </h2>

              {filteredFaqs.length > 0 ? (
                <div className="space-y-4">
                  {filteredFaqs.map((faq, index) => (
                    <div
                      key={index}
                      className="border border-gray-200 rounded-lg overflow-hidden hover:shadow-md transition-shadow"
                    >
                      <button
                        onClick={() => setExpandedFaq(expandedFaq === index ? null : index)}
                        className="w-full flex items-center justify-between p-4 text-left hover:bg-gray-50 transition-colors"
                      >
                        <span className="font-semibold text-[#001F3F] pr-4">{faq.question}</span>
                        <svg
                          className={`w-5 h-5 text-[#D4AF37] flex-shrink-0 transition-transform ${
                            expandedFaq === index ? 'rotate-180' : ''
                          }`}
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                        </svg>
                      </button>
                      {expandedFaq === index && (
                        <div className="px-4 pb-4 pt-2 text-gray-700 border-t border-gray-100">
                          {faq.answer}
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              ) : (
                <div className="text-center py-12">
                  <svg className="w-16 h-16 text-gray-300 mx-auto mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                  <p className="text-gray-500">Aucun résultat trouvé pour "{searchQuery}"</p>
                </div>
              )}
            </div>

            {/* Formulaire de contact */}
            <div className="bg-white rounded-xl shadow-sm p-6 md:p-8 mt-6">
              <h2 className="text-2xl font-bold text-[#001F3F] mb-2">Vous ne trouvez pas votre réponse ?</h2>
              <p className="text-gray-600 mb-6">Contactez-nous directement, notre équipe vous répondra rapidement.</p>

              <form className="space-y-4">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-semibold text-[#001F3F] mb-2">
                      Nom complet<span className="text-red-600">*</span>
                    </label>
                    <input
                      type="text"
                      placeholder="Votre nom"
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#D4AF37] focus:border-transparent"
                      required
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-semibold text-[#001F3F] mb-2">
                      Email<span className="text-red-600">*</span>
                    </label>
                    <input
                      type="email"
                      placeholder="votre@email.com"
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#D4AF37] focus:border-transparent"
                      required
                    />
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-semibold text-[#001F3F] mb-2">
                    Sujet<span className="text-red-600">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Sujet de votre message"
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#D4AF37] focus:border-transparent"
                    required
                  />
                </div>

                <div>
                  <label className="block text-sm font-semibold text-[#001F3F] mb-2">
                    Message<span className="text-red-600">*</span>
                  </label>
                  <textarea
                    rows="5"
                    placeholder="Décrivez votre problème ou votre question..."
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#D4AF37] focus:border-transparent resize-none"
                    required
                  ></textarea>
                </div>

                <button
                  type="submit"
                  className="w-full md:w-auto px-8 py-3 bg-[#D4AF37] text-white font-semibold rounded-lg hover:bg-[#c09d2a] transition-colors shadow-md"
                >
                  Envoyer le message
                </button>
              </form>
            </div>

            {/* Infos de contact */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-6">
              <div className="bg-white rounded-xl shadow-sm p-6 text-center">
                <div className="w-12 h-12 bg-[#D4AF37] rounded-full flex items-center justify-center mx-auto mb-3">
                  <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  </svg>
                </div>
                <h3 className="font-semibold text-[#001F3F] mb-1">Email</h3>
                <p className="text-sm text-gray-600">support@KUDHI.ci</p>
              </div>

              <div className="bg-white rounded-xl shadow-sm p-6 text-center">
                <div className="w-12 h-12 bg-[#D4AF37] rounded-full flex items-center justify-center mx-auto mb-3">
                  <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                  </svg>
                </div>
                <h3 className="font-semibold text-[#001F3F] mb-1">Téléphone</h3>
                <p className="text-sm text-gray-600">+225 07 00 00 00 00</p>
              </div>

              <div className="bg-white rounded-xl shadow-sm p-6 text-center">
                <div className="w-12 h-12 bg-[#D4AF37] rounded-full flex items-center justify-center mx-auto mb-3">
                  <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </div>
                <h3 className="font-semibold text-[#001F3F] mb-1">Horaires</h3>
                <p className="text-sm text-gray-600">Lun-Ven: 9h-18h</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default HelpPage
